import React from "react";
import { PostActionButton } from "./PostCard.styles";
import Images from "config/Images";
import { togglePostLike } from "apis/PostServiceApi";
import { useAppDispatch } from "store/hooks";
import { updateLikeStatus } from "store/feed/feed.slice";

const LikeAction: React.FC<LikeActionProps> = ({
  postId,
  postOwnerId,
  isLiked,
}) => {
  const dispatch = useAppDispatch();

  const handleLike = async () => {
    try {
      const res = await togglePostLike({ postId, postOwnerId });
      dispatch(
        updateLikeStatus({
          postId,
          userAvatar: res.SocialAvatarUrl,
          isLiked: res.isLiked,
        })
      );
    } catch (err) {
      console.error("togglePostLike error", err);
    }
  };

  return (
    <PostActionButton isLiked={isLiked} onClick={handleLike}>
      <img src={Images.likeIcon} alt="Like" />
    </PostActionButton>
  );
};

export default LikeAction;
